import { render, staticRenderFns } from "./SectionSecurity.vue?vue&type=template&id=28c38cc0"
import script from "./SectionSecurity.vue?vue&type=script&lang=ts&setup=true"
export * from "./SectionSecurity.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports